/**
 * Get a list of the current product's event dates
 * @param {Object} state The global state object
 * @returns {Array} Array of product's event dates
 */
export const getEventAttendees = (state, eventId) => {
  return state.dateList.find((date) => date.id === eventId).attendees
}
